export class CryptoHelper {
    static encryptSync(data) {
        const encoder = new TextEncoder();
        const dataBytes = encoder.encode(data);
        const keyBytes = encoder.encode(CryptoHelper.secretKeyForEncryption);
        const encrypted = new Uint8Array(dataBytes.length);
        for (let i = 0; i < dataBytes.length; i++) {
            encrypted[i] = dataBytes[i] ^ keyBytes[i % keyBytes.length];
        }
        let binaryString = '';
        for (let i = 0; i < encrypted.length; i++) {
            binaryString += String.fromCharCode(encrypted[i]);
        }
        return btoa(binaryString);
    }
    static decryptSync(encrypted) {
        const binaryString = atob(encrypted);
        const encryptedBytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            encryptedBytes[i] = binaryString.charCodeAt(i);
        }
        const encoder = new TextEncoder();
        const keyBytes = encoder.encode(CryptoHelper.secretKeyForEncryption);
        const decrypted = new Uint8Array(encryptedBytes.length);
        for (let i = 0; i < encryptedBytes.length; i++) {
            decrypted[i] = encryptedBytes[i] ^ keyBytes[i % keyBytes.length];
        }
        const decoder = new TextDecoder();
        return decoder.decode(decrypted);
    }
}
CryptoHelper.secretKeyForEncryption = [
    "f8A2", "d9B3", "c4E5", "f6G7", "h8I9", "j0K1", "l2M3", "n4O5"
].join("");
